import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import {
  DataKindMaintenancePageContext,
  DataKindMaintenancePageInitialState,
} from ".";

export const DataKindMaintenancePageStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(
    DataKindMaintenancePageInitialState,
  );
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <DataKindMaintenancePageContext.Provider value={context}>
      {children}
    </DataKindMaintenancePageContext.Provider>
  );
};
